import { createFileRoute } from "@tanstack/react-router";
import { PageHead, Panel } from "@/components/dashboard-shell";

export const Route = createFileRoute("/donor/profile")({ component: DonorProfile });

function DonorProfile() {
  return (
    <>
      <PageHead title="Profile" subtitle="Manage your account and preferences." />
      <div className="grid gap-4 lg:grid-cols-2">
        <Panel title="Personal details">
          <F label="Name" defaultValue="Rahul Shah" />
          <F label="Mobile" defaultValue="+91 98xx xxx xxx" />
          <F label="Email" defaultValue="rahul@example.com" />
          <F label="PAN (for 80G)" defaultValue="ABCDE1234F" />
        </Panel>
        <Panel title="Preferences">
          <Toggle label="Email me cause updates" defaultChecked />
          <Toggle label="Email me monthly impact digest" defaultChecked />
          <Toggle label="WhatsApp receipts" />
        </Panel>
      </div>
    </>
  );
}

function F({ label, defaultValue }: { label: string; defaultValue: string }) {
  return (
    <label className="block py-2">
      <span className="text-xs text-foreground/60">{label}</span>
      <input
        defaultValue={defaultValue}
        className="mt-1 w-full rounded-xl border border-border bg-background px-4 py-2 text-sm"
      />
    </label>
  );
}
function Toggle({ label, defaultChecked }: { label: string; defaultChecked?: boolean }) {
  return (
    <label className="flex items-center justify-between py-2 text-sm">
      <span>{label}</span>
      <input
        type="checkbox"
        defaultChecked={defaultChecked}
        className="h-4 w-4 accent-[var(--maroon)]"
      />
    </label>
  );
}
